"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _rendererCore = require("@quillforms/renderer-core");
var _lodash = require("lodash");
var _choicesWrapper = _interopRequireDefault(require("./choices-wrapper"));
/**
 * QuillForms Depndencies
 */

/**
 * WordPress Dependencies
 */

/**
 * External Dependencies
 */

/**
 * Internal Dependencies
 */

let multipleChoiceTimer;
const MultipleChoiceOutput = props => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    showNextBtn,
    setValidationErr,
    val,
    setVal,
    next,
    isAnswerLocked,
    isActive,
    isAnimating,
    showErrMsg,
    isPreview,
    isReviewing,
    setIsAnswerCorrect
  } = props;
  const {
    multiple,
    required,
    min,
    max
  } = attributes;
  const messages = (0, _rendererCore.useMessages)();
  const correctIncorrectQuiz = (0, _rendererCore.useCorrectIncorrectQuiz)();
  const [choiceClicked, setChoiceClicked] = (0, _react.useState)(null);
  const checkfieldValidation = $val => {
    if (required === true && (!$val || $val.length === 0)) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.required']);
    } else {
      if ((0, _lodash.size)($val) > 0 && correctIncorrectQuiz?.enabled && correctIncorrectQuiz?.showAnswersDuringQuiz) {
        // $val is array of selected choices
        // const isCorrect = correctIncorrectQuiz?.questions?.[id]?.correctAnswers?.includes($val);
        // if each value from $val includes any answer from those in the correctAnswers array, then it is correct, not the opposite.

        const isCorrect = $val.every(answer => correctIncorrectQuiz?.questions?.[id]?.correctAnswers?.includes(answer));
        // const isCorrect = correctIncorrectQuiz?.questions?.[id]?.correctAnswers?.every((answer) => $val.includes(answer));
        setIsAnswerCorrect(isCorrect);
      }
      if (multiple && min && (0, _lodash.size)($val) < min) {
        setIsValid(false);
        setValidationErr(messages['label.errorAlert.minChoices']);
      } else if (multiple && max && (0, _lodash.size)($val) > max) {
        setIsValid(false);
        setValidationErr(messages['label.errorAlert.maxChoices']);
      } else {
        setIsValid(true);
        setValidationErr(null);
      }
    }
  };
  (0, _react.useEffect)(() => {
    return () => clearTimeout(multipleChoiceTimer);
  }, []);
  (0, _react.useEffect)(() => {
    if (!isActive) {
      clearTimeout(multipleChoiceTimer);
    }
    if (!isActive && !isAnimating) {
      setChoiceClicked(null);
    }
  }, [isActive, isAnimating]);
  (0, _react.useEffect)(() => {
    clearTimeout(multipleChoiceTimer);
    if (choiceClicked && val?.length > 0 && !multiple) {
      multipleChoiceTimer = setTimeout(() => {
        next();
      }, 600);
    }
  }, [choiceClicked]);
  (0, _react.useEffect)(() => {
    if (isPreview || !isReviewing) checkfieldValidation(val);
  }, [attributes, correctIncorrectQuiz]);
  (0, _react.useEffect)(() => {
    if (val?.length > 0) {
      setIsAnswered(true);
    } else {
      setIsAnswered(false);
    }
    if (multiple) {
      if (val?.length > 0) {
        showNextBtn(true);
      }
    }
  }, [val, attributes]);
  return (0, _react.createElement)("div", {
    className: "qf-multiple-choice-block-renderer"
  }, (0, _react.createElement)(_choicesWrapper.default, {
    attributes: attributes,
    id: id,
    val: val,
    isActive: isActive,
    isAnswerLocked: isAnswerLocked,
    correctIncorrectQuiz: correctIncorrectQuiz,
    checkfieldValidation: checkfieldValidation,
    setVal: setVal,
    setChoiceClicked: val => {
      showErrMsg(false);
      setChoiceClicked(val);
    }
  }));
};
var _default = exports.default = MultipleChoiceOutput;
//# sourceMappingURL=display.js.map